var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2599_5104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.44281 10.5V9H9.95781V10.5H8.44281ZM5.41281 10.5V9H6.92781V10.5H5.41281ZM11.4728 10.5V9H12.9878V10.5H11.4728ZM8.44281 13.5V12H9.95781V13.5H8.44281ZM5.41281 13.5V12H6.92781V13.5H5.41281ZM11.4728 13.5V12H12.9878V13.5H11.4728ZM2.38281 16.5V3H4.65531V1.5H6.17031V3H12.2303V1.5H13.7453V3H16.0178V16.5H2.38281ZM3.89781 15H14.5028V7.5H3.89781V15ZM3.89781 6H14.5028V4.5H3.89781V6Z",
    fill: "#374E92"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2599_5104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.18,
    height: 18,
    fill: "white",
    transform: "translate(0.110352)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDate);
export default __webpack_public_path__ + "static/media/icon_date.b6150394ce21d1e9ea9202c49c2640df.svg";
export { ForwardRef as ReactComponent };